<template>
  <div class="content info-text error-message">
    {{messages.errorGeneralMessage}}
    <v-btn
      :ripple="false"
      class="submit back"
      flat
      @click="backToStart"
    >{{messages.backToStartPageButtonText}}</v-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ErrorPage',
  computed: {
    ...mapState([
      'messages'
    ])
  },
  methods: {
    backToStart () {
      this.$router.push({
        name: 'booking'
      })
    }
  }
}
</script>

<style lang="scss">
</style>
